import React from "react";
import { useNavigate } from "react-router-dom";
import { useLogout } from "./LogoutProvider";
import { toast } from "react-toastify";
import { io } from "socket.io-client"; // only if you manage socket here

// Optional: if you have a global socket instance, import it instead
// import { socket } from "../utils/socket";

export const LogoutButton = ({ socket }) => {
  const { logout } = useLogout();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // 1️⃣ Disconnect socket if connected
      if (socket && socket.connected) {
        socket.disconnect();
        console.log("Socket disconnected on logout");
      } else {
        // fallback if global socket is used
        const existingSocket = window.socket || io(process.env.REACT_APP_BASE_URL, { autoConnect: false });
        if (existingSocket.connected) {
          existingSocket.disconnect();
          console.log("Global socket disconnected on logout");
        }
      }

      // 2️⃣ Perform logout API + cleanup
      if (logout) {
        await logout();
      } else {
        localStorage.removeItem("user");
        localStorage.removeItem("isRequesting");
        toast.success("You have been logged out successfully!");
        navigate("/signin", { replace: true });
      }

      // 3️⃣ Extra cleanup (safety)
      sessionStorage.clear();
      navigator.serviceWorker.getRegistrations().then((regs) =>
        regs.forEach((reg) => reg.unregister())
      );

      console.log("Logout complete — user fully disconnected");
    } catch (error) {
      console.error("Error during logout:", error);
      toast.error("Logout failed. Please try again.");
    }
  };

  return (
    <button
      onClick={handleLogout}
      style={{
        padding: "8px 12px",
        backgroundColor: "#f44336",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
      }}
    >
      Logout
    </button>
  );
};
